import { createFileRoute } from "@tanstack/react-router";
import { BellRing, Bot, IdCard, MessageCircle } from "lucide-react";
import { establishmentQuery } from "@/api/establishment";
import { personaPresetsQuery, personaQuery } from "@/api/persona";
import { reminderConfigsQuery } from "@/api/reminders";
import { wabaPhoneQuery } from "@/api/waba";
import { warmQueries } from "@/api/warm";
import { useAuth } from "@/auth/AuthProvider";
import { LembretesSection } from "@/components/configuracoes/LembretesSection";
import { PerfilComercialSection } from "@/components/configuracoes/PerfilComercialSection";
import { PersonaSection } from "@/components/configuracoes/PersonaSection";
import { SettingsCard } from "@/components/configuracoes/SettingsCard";
import { WhatsappConnection } from "@/components/whatsapp-connection";

export const Route = createFileRoute("/_authed/configuracoes/whatsapp")({
  loader: ({ context: { queryClient, establishmentId } }) =>
    warmQueries(queryClient, [
      wabaPhoneQuery(),
      establishmentQuery(establishmentId),
      personaQuery(),
      personaPresetsQuery(),
      reminderConfigsQuery(),
    ]),
  staticData: {
    title: "WhatsApp e bot",
    subtitle: "Conexão do número, jeito de falar do assistente e lembretes.",
  },
  component: WhatsappPage,
});

/**
 * Tudo que o cliente final vê chegar pelo WhatsApp: por onde a mensagem sai
 * (a conexão), com que voz (a persona) e quando o lembrete dispara sozinho.
 * Cada seção salva por conta própria.
 */
function WhatsappPage() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div className="space-y-6">
      {/* A conexão real é o Embedded Signup da Meta (Cloud API): o número
          passa a pertencer à WABA do estabelecimento, e é isso que permite o
          bot atender por API em vez de por celular pareado. O estado vem do
          servidor via WhatsappConnection. */}
      <SettingsCard icon={MessageCircle} title="Conexão">
        <WhatsappConnection />
      </SettingsCard>

      {/* Vem logo depois da conexão porque só existe com número
          conectado, e porque é a primeira coisa que o cliente vê ao tocar
          no nome do negócio — antes mesmo de o bot dizer qualquer coisa. */}
      <SettingsCard
        icon={IdCard}
        title="Perfil comercial"
        description="O que seu cliente vê ao tocar no nome do negócio dentro da conversa."
      >
        <PerfilComercialSection />
      </SettingsCard>

      <SettingsCard
        icon={Bot}
        title="Persona do assistente"
        description="O nome e o jeito de falar do bot — dá pra mudar quando quiser."
      >
        <PersonaSection />
      </SettingsCard>

      <SettingsCard
        icon={BellRing}
        title="Lembretes"
        description="Quando o cliente recebe o lembrete automático do agendamento no WhatsApp."
      >
        <LembretesSection establishmentId={user.establishment_id} />
      </SettingsCard>
    </div>
  );
}
